<div class="boxWhite">
  <h4>IMPRIMIR</h4>

  <button class="btn btnClose" (click)="close()">
    <img src="assets/img/icoClose.svg" alt="">
  </button>

  <div class="contModal">
    <div class="row">
      <div class="col-sm-auto">
        <h6 class="clBlack">ID</h6>
        <p class="clGray mb-4">{{conductor?.visibleId}}</p>
      </div>
      <div class="col-sm">
        <h6 class="clBlack">NOMBRE CONDUCTOR</h6>
        <p class="clGray mb-4">{{conductor?.nombres}} {{conductor?.apellidoPaterno}}</p>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <div class="boxInsideModal bgLightGray mb-4 d-flex align-items-center justify-content-between">
          <div class="d-flex flex-column justify-content-center">
            <h6>ESTADO ACTUAL</h6>
            <p class="clLightBlue m-0 fw-medium">
              {{conductor?.estado}}
              <span class="clBlack">({{getTiempoEnEstadoHHmm}})</span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <!--div class="radios mb-3" [formGroup]="tiposForm">
      <label class="itemRadio">
        <input type="radio" name="tipoImpresion" formControlName="tipoImpresion" id="tipoImpresion1" value="TODOS">
        <span class="boxRadio">TODOS</span>
      </label>

      <label class="itemRadio">
        <input type="radio" name="tipoImpresion" formControlName="tipoImpresion" id="tipoImpresion2" value="COLACION">
        <span class="boxRadio">COLACION</span>
      </label>

      <label class="itemRadio">
        <input type="radio" name="tipoImpresion" formControlName="tipoImpresion" id="tipoImpresion3" value="JORNADA">
        <span class="boxRadio">JORNADA</span>
      </label>
    </div-->
  </div>

  <div class="footModal">
    <!--CON-1056: un solo vale para los cinco estados con comprobante, reimprimible mientras dure-->
    <button class="btn btnBlack w-100 mb-3"
      [disabled]="!puedeImprimirValeEstado || procesandoPdf"
      (click)="imprimirValeEstado()" *ngIf="from == 'conductores' && tienePermisoImprimirValeEstado()">
      IMPRIMIR COMPROBANTE
    </button>

    <button class="btn btnBlack w-100 mb-2" [disabled]="procesandoPdf" (click)="getFinJornadaPDF()" *ngIf="from == 'conductores' && tienePermisoImprimirJornada()">
      IMPRIMIR JORNADA
    </button>

    <!--CON-1057: el tooltip va en el span porque un boton deshabilitado no recibe eventos de mouse-->
    <span *ngIf="from == 'sinoptico' && tienePermisoImprimirRutaViaje()" [tooltip]="tooltipImprimirRutaViaje" class="d-block">
      <button class="btn btnBlack w-100 mb-2" [disabled]="procesandoPdf || !viajeConfirmado" (click)="getRutaViajePDF()">
        IMPRIMIR RUTA DE VIAJE
      </button>
    </span>

  </div>
</div>
